/**
 * Helper function to validate RecorderPlugin instance.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


/**
 * @param {IPlugin} plugin Plugin for test
 * @return {boolean}
 */
export default plugin => typeof plugin !== 'undefined'
                           && typeof plugin.init === 'function'
                           && typeof plugin.check === 'function';
